<template>
    <div class="automation-wizard-field-date">
        <CompassFormItem v-bind="formItemProps">
            <CompassInput
                :value="localValue"
                type="number"
                :min="0"
                menuClass="automation-wizard-field-date"
                @input="handleInput"
            >
                <template #suffix>
                    <span
                        class="automation-wizard-field-date__suffix typographies-paragraph-medium-regular"
                    >
                        {{ $t.__('common.labels.day_s') }}
                    </span>
                </template>
            </CompassInput>
        </CompassFormItem>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number],
            default: '',
        },
    },
    emits: ['update:value'],
    computed: {
        localValue() {
            return this.parseValue(this.value);
        },
        formItemProps() {
            return {
                ...this.field.props?.formItem,
                label: this.field.props?.formItem?.label || '',
                info: this.field.props?.formItem?.info || '',
                required: this.field.required || false,
                requiredLabel:
                    this.field.props?.formItem?.requiredLabel ||
                    this.$t.__('common.labels.required'),
                error: '',
            };
        },
    },
    methods: {
        parseValue(value) {
            if (typeof value === 'string' && value.includes('day')) {
                const match = value.match(/\+\s*(\d+)\s*day/);
                return match ? parseInt(match[1], 10) : 0;
            }
            if (typeof value === 'number') {
                return value;
            }
            return 0;
        },
        handleInput(event) {
            const inputValue = event.target.value;
            const numValue = parseInt(inputValue, 10) || 0;
            const dateValue = `+${numValue}day`;
            this.$emit('update:value', dateValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-field-date {
    &__suffix {
        color: var(--colors-common-text-standard-placeholder);
    }
}
</style>
